import { sepAPI } from '../API';
import {
  SEPInitiatePhaseRow,
  ResetToValidationBody,
  ResetToValidationResult,
} from '../../../shared/types/SEP';
import { TaskTemplate } from '../../../shared/types/Task';
import { setSnackbarForEndpoint } from '../../utils/snackbar';

export const adminSlice = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Get SEPs in active status and initiate phase
    getSEPsInInitiatePhase: builder.query<SEPInitiatePhaseRow[], void>({
      query: () => 'admin/seps/initiate-phase',
      providesTags: ['SEPs'],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          errorMessage: 'There was a problem getting SEPs in initiate phase.',
        });
      },
    }),

    // Get validation phase task templates
    getValidationTaskTemplates: builder.query<TaskTemplate[], void>({
      query: () => 'admin/validation-task-templates',
      providesTags: ['TaskTemplate'],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          errorMessage: 'There was a problem getting validation task templates.',
        });
      },
    }),

    // Reset SEPs to validation phase
    resetSEPsToValidation: builder.mutation<ResetToValidationResult, ResetToValidationBody>({
      query: (body) => ({
        url: 'admin/seps/reset-to-validation',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['SEPs', 'Tasks', 'TasksForSEP'],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: 'SEPs successfully reset to validation phase!',
          errorMessage: 'There was a problem resetting SEPs to validation phase.',
        });
      },
    }),
  }),
});

export const {
  useGetSEPsInInitiatePhaseQuery,
  useGetValidationTaskTemplatesQuery,
  useResetSEPsToValidationMutation,
} = adminSlice;
